import { render, staticRenderFns } from "./Ajuste.vue?vue&type=template&id=d8b8f57c&"
import script from "./Ajuste.vue?vue&type=script&lang=js&"
export * from "./Ajuste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports